export default "__VITE_ASSET__DkrCyBpc__"